import { apiClient } from "@/services/HttpService";
// 获取部门树
export function deptsTree() {
  return apiClient.get(`/depts/tree`);
}
//上移/下移
export function deptsMoveUp(deptId, path) {
  return apiClient.patch(`/depts/${deptId}/${path}`);
}
//保存部门
export function deptsSubmit(params) {
  return apiClient.post(`/depts`, params);
}

//修改部门
export function deptsUpdate(params) {
  return apiClient.post(`/depts/update`, params);
}
//删除部门
export function deptsDel(deptId) {
  return apiClient.delete(`/depts/${deptId}`);
}
